import React, { useCallback, useEffect, useState } from 'react'
import { Card, Space, Button, Tag } from 'antd'
import Table, { type ColumnsType } from 'antd/es/table'
import { type AxiosError } from 'axios'
import { useAppDispatch } from 'Hooks/ReduxHook'
import { PlusOutlined } from '@ant-design/icons'
import { setLoader } from 'Store/slices/commonSlice'
import Http, { type ApiErrorData } from 'Util/Http'
import { type IVehicle } from 'Util/Interface'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

const Vehicles: React.FC = () => {
  const [tableData, setTableData] = useState<IVehicle[]>([])

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const fetch = useCallback(async () => {
    try {
      dispatch(setLoader(true))
      const response = await Http(`/vehicle`)
      if (response.data?.status === 'success' && response?.data?.code === 200) {
        dispatch(setLoader(false))
        setTableData(response.data?.data)
      } else {
        setTableData([])
        dispatch(setLoader(false))
      }
    } catch (error: any) {
      const err = error as AxiosError<ApiErrorData>
      toast.error(err.response?.data?.message ?? 'Something Went Wrong')
      setTableData([])
      dispatch(setLoader(false))
    }
  }, [dispatch])

  useEffect(() => {
    void fetch()
  }, [fetch])

  const handleDelete = async (params: IVehicle) => {
    try {
      const response = await Http(`/vehicle/${String(params.id)}`, {
        method: 'DELETE',
      })
      if (response.data?.status === 'success' && response?.data?.code === 200) {
        toast.success(response?.data?.message)
        void fetch()
      }
    } catch (error) {
      const err = error as AxiosError<ApiErrorData>
      toast.error(err.response?.data?.message ?? 'Something Went Wrong')
    }
  }

  const columns: ColumnsType<IVehicle> = [
    {
      title: 'Sr. No.',
      key: 'serial',
      dataIndex: 'serial',
      render: (_value, _record, index: number) => index + 1,
    },
    {
      title: 'Vechicle Name',
      key: 'vehicleName',
      dataIndex: 'vehicleName',
    },
    {
      title: 'Car Type',
      key: 'car_data',
      dataIndex: 'car_data',
      render: (_, data: IVehicle) => <>{data?.vehicle?.name}</>,
    },
    {
      title: 'Capacity',
      key: 'capacity',
      dataIndex: 'capacity',
      render: (_, data: IVehicle) => <>{data?.vehicle?.capacity}</>,
    },
    {
      title: 'Vehicle No',
      key: 'vehicleNo',
      dataIndex: 'vehicleNo',
    },
    // {
    //   title: 'Registration Document',
    //   key: 'registrationDoc',
    //   dataIndex: 'registrationDoc',
    //   render: (value: string) => {
    //     return <img src={`${ATTCHMENT_BASE_URL}/${value}`} alt="" height={60} width={60} />
    //   },
    // },
    {
      title: 'Registration No',
      key: 'registrationNo',
      dataIndex: 'registrationNo',
    },
    {
      title: 'Registration Date',
      key: 'registrationStartDate',
      dataIndex: 'registrationStartDate',
    },
    {
      title: 'Registration Expire',
      key: 'registrationEndDate',
      dataIndex: 'registrationEndDate',
    },
    // {
    //   title: 'Insurance Document',
    //   key: 'insuranceDoc',
    //   dataIndex: 'insuranceDoc',
    //   render: (value: string) => {
    //     return <img src={`${ATTCHMENT_BASE_URL}/${value}`} alt="" height={60} width={60} />
    //   },
    // },
    // {
    //   title: 'Insurance No',
    //   key: 'insuranceNo',
    //   dataIndex: 'insuranceNo',
    // },
    // {
    //   title: 'Insurance Date',
    //   key: 'insuranceStartDate',
    //   dataIndex: 'insuranceStartDate',
    // },
    // {
    //   title: 'Insurance Expire',
    //   key: 'insuranceEndDate',
    //   dataIndex: 'insuranceEndDate',
    // },
    // {
    //   title: 'Vechicle Fitness',
    //   key: 'vehicleFitness',
    //   dataIndex: 'vehicleFitness',
    // },
    {
      title: 'Active',
      key: 'status',
      dataIndex: 'status',
      render: (value) => <Tag color={value === 'Active' ? 'green' : 'red'}>{value}</Tag>,
    },
    {
      title: 'Action',
      dataIndex: 'actions',
      render: (_text, record: IVehicle) => {
        return (
          <Space>
            <Button
              onClick={() => {
                navigate(`/vehicle/view/${record.id}`)
              }}
            >
              View
            </Button>
            <Button
              onClick={() => {
                navigate(`/vehicle/edit/${record.id}`)
              }}
            >
              Update
            </Button>
            <Button
              danger
              onClick={() => {
                void handleDelete(record)
              }}
            >
              Delete
            </Button>
          </Space>
        )
      },
    },
  ]

  return (
    <>
      <div className="content-wrapper">
        <Card
          className="card-wrapper"
          title={
            <div className="row justify-between">
              <div>
                <h3>Vehicle List</h3>
              </div>
              <div>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    navigate(`/vehicle/add`)
                  }}
                >
                  Add Vehicle
                </Button>
              </div>
            </div>
          }
          style={{ padding: '1.25rem 1.25rem 0' }}
        >
          <Table columns={columns} dataSource={tableData} rowKey={(dataIndex: IVehicle) => dataIndex?.id} bordered size="middle" />
        </Card>
      </div>
    </>
  )
}

export default Vehicles
